import htmx from "htmx.org";
window.htmx = htmx;
import Swiper from "swiper";
import { Navigation, Autoplay, EffectFade, Pagination } from "swiper/modules";
import Alpine from "alpinejs";
import focus from "@alpinejs/focus";
import collapse from "@alpinejs/collapse";

// Code:
Swiper.use([Navigation, Autoplay, EffectFade, Pagination]);

// Components
import mainmenu from "./mainmenu.js";
import backdrop from "./backdrop.js";
import agenda from "./agenda.js";
import flyers from "./flyers.js";
import video from "./video.js";
import carousel from "./carousel.js";
import accordion from "./accordion.js";

// Components
Alpine.data("mainmenu", mainmenu);
Alpine.data("backdrop", backdrop);
Alpine.data("agenda", agenda);
Alpine.data("flyers", flyers);
Alpine.data("video", video);
Alpine.data("carousel", carousel);
Alpine.data("accordion", accordion);

window.Swiper = Swiper;
window.Alpine = Alpine;
Alpine.plugin(focus);
Alpine.plugin(collapse);
Alpine.start();
